import {useEffect} from 'react';
import Head from 'next/head';
import {Flex} from '@chakra-ui/react';
import Confetti from 'react-confetti';

import {useTranslate} from '@eksab/i18n';
import {useWindowSize} from '@eksab/hooks/useWindowSize';

import {MoreTriviaGames} from './MoreTriviaGames';
import {PlayHeader} from './PlayHeader';
import {Winner} from './Winner';
import {DemoWinner} from './DemoWinner';
import {Loser} from './Loser';
import {useTriviaStore} from '../state';
import {getScorePercentage} from './utils';
import {useEmbedded} from '@eksab/hooks/useEmbedded';

export function Score() {
  const t = useTranslate();

  const challenge = useTriviaStore((state) => state.challenge!);
  const currentScore = useTriviaStore((state) => state.currentScore);

  const {height, width} = useWindowSize();

  const {isEmbedded} = useEmbedded();

  useEffect(() => {
    if (currentScore === challenge?.no_of_questions) {
      const audio = new Audio('/sounds/winner.wav');
      audio.volume = 0.4;
      audio.play();
    }
    mixpanel?.track('Trivia - Score', {
      score: `${currentScore}/${challenge!.no_of_questions}`,
      percentage: getScorePercentage(currentScore, challenge!.no_of_questions),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex="1" flexDir="column">
      <Head>
        <title>{`${t('trivia.score.header')} - ${t('app.trivia')} | ${t('app.name')}`}</title>
      </Head>

      <PlayHeader scoreProps={{score: currentScore, noOfQuestions: challenge?.no_of_questions || 0}} />

      {challenge.no_of_questions === currentScore ? (
        challenge.prize ? (
          <Winner alignSelf="center" />
        ) : (
          <DemoWinner />
        )
      ) : (
        <Loser alignSelf="center" />
      )}

      {!isEmbedded && <MoreTriviaGames mt="4" />}

      {width && height && currentScore === challenge?.no_of_questions && (
        <Confetti height={height} width={width} gravity={0.05} numberOfPieces={100} />
      )}
    </Flex>
  );
}
